<template>
  <div class="cdfp-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right; position: relative; z-index: 99;">
              <el-button-group>
                <el-button :type="mark===5?'primary':''" size="small" @click="changeMark(5)">未分配</el-button>
                <el-button :type="mark===6?'primary':''" size="small" @click="changeMark(6)">已分配</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.order_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.brand_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="评估时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.assess_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="mark===6"
                    label="已分配人员"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500">{{ scope.row.splitname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分配状态"
                    width="100"
                    align="center"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.status===5" :disable-transitions="true" size="mini" type="warning">待分配</el-tag>
                      <el-tag v-if="scope.row.status===6" :disable-transitions="true" size="mini">已分配</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :width="mark===6 ? 210 : 120"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.status===5" size="mini" icon="el-icon-sort" type="primary" plain @click.stop="allot(scope.row)">分配</el-button>
                      <el-button v-if="scope.row.status===6" size="mini" icon="el-icon-copy-document" @click.stop="split(scope.row)">拆分</el-button>
                      <el-button v-if="scope.row.status===6" size="mini" icon="el-icon-sort" type="warning" plain @click.stop="allot(scope.row)">重新分配</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editForm.status === 6 ? '拆单重新分配' : '拆单分配'"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-alert
        style="margin-bottom: 20px;"
        title="注意事项"
        type="warning"
        description="拆单重新分配后将当前订单及所有拆分后的订单（如果有）全部初始化，即到待拆单状态，请谨慎操作！"
        :closable="false"
        show-icon>
      </el-alert>
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.status === 6 && editForm.splitname" label="原拆单人员" prop="splitname">
          <el-input v-model="editForm.splitname" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆单人员" prop="splitid">
          <UserSelect v-model="editForm.splitid" :groupid="user.dGroupid" :userid="user.dUserid"></UserSelect>
        </el-form-item>
        <el-form-item label="分配备注" prop="content">
          <el-input v-model="editForm.content" type="textarea" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">
            {{ editForm.status === 6 ? '重新分配' : '立即分配' }}
          </el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="拆分订单"
      :visible.sync="editSplitVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editSplitForm" :model="editSplitForm" :rules="editSplitRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editSplitForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆分个数" prop="num">
          <el-input-number v-model="editSplitForm.num" :min="2" :max="10" @change="handleSplitChange"></el-input-number>
          <span style="color:#99a9bf;font-size: 12px;margin-left: 10px">最少拆分2个，最多不超过10个</span>
        </el-form-item>
        <el-form-item v-for="(item, index) in editSplitForm.orderInfo" :key="item.key" :label="'订单'+(index+1)" :prop="'orderInfo.' + index +'.address'" :rules="editSplitRules.address">
          <el-input v-model="item.address" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editSplitloading" @click="subSplitEdit('editSplitForm')">立即提交</el-button>
          <el-button @click="editSplitVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, splitOrder, orderSplit } from '@/api/erp'
import { getBrandList } from '@/api/work'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import UserSelect from '@/components/UserSelect'

export default {
  name: 'Cdfp',
  components: {
    UserSelect,
    MultiFile,
    MultiImg
  },
  data() {
    return {
      mark: 5,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      editForm: {
        orderid: '',
        ordername: '',
        splitid: null,
        content: '',
        files: [],
        imgids: []
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        splitid: [{ required: true, message: '请选择拆单人员', trigger: 'change' }]
      },
      editSplitVisible: false,
      editSplitloading: false,
      editSplitForm: {
        orderid: '',
        ordername: '',
        address: '',
        num: 2,
        orderInfo: []
      },
      editSplitRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        num: [{ required: true, message: '请输入拆分个数', trigger: 'blur' }],
        address: [{ required: true, message: '请输入订单地址', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    changeMark(n) {
      if (n === this.mark) {
        return false
      } else {
        this.mark = n
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: this.mark,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    allot(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.splitid = null
      this.editForm.imgids = []
      this.editForm.status = row.status
      this.editForm.splitname = row.splitname
      this.editVisible = true
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAllotOrder()
        } else {
          return false
        }
      })
    },
    SubAllotOrder() {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          splitid: this.editForm.splitid,
          content: this.editForm.content,
          fileids: this.editForm.files.join(','),
          imgids: this.editForm.imgids.join(',')
        }
        splitOrder(data).then(response => {
          this.$message({
            message: '拆单已分配成功',
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    split(row) {
      this.editSplitForm.orderid = row.order_id
      this.editSplitForm.ordername = row.order_num + ' / ' + row.address
      this.editSplitForm.num = 2
      this.editSplitForm.address = row.address
      this.editSplitForm.orderInfo = [{ address: this.editSplitForm.address + '（第一批）' }, { address: this.editSplitForm.address + '（第二批）' }]
      this.editSplitVisible = true
    },
    toChinese(values) {
      const chin_list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      const sn = parseInt(values)
      return chin_list[sn - 1]
    },
    handleSplitChange(val, oldValue) {
      if (val > oldValue) {
        for (let i = oldValue; i < val; i++) {
          this.editSplitForm.orderInfo.push({ address: this.editSplitForm.address + '（第' + this.toChinese(i + 1) + '批）' })
        }
      } else if (val < oldValue) {
        for (let i = this.editSplitForm.orderInfo.length; i > val; i--) {
          this.editSplitForm.orderInfo.splice((i - 1), 1)
        }
      }
    },
    subSplitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editSplitloading) {
            this.editSplitloading = true
            const names = []
            for (const oi of this.editSplitForm.orderInfo) {
              names.push(oi.address)
            }
            let namesStr = JSON.stringify(names)
            namesStr = namesStr.substring(1, namesStr.length - 1)
            const data = {
              userid: this.user.dUserid,
              orderid: this.editSplitForm.orderid,
              num: this.editSplitForm.num,
              names: namesStr
            }
            orderSplit(data).then(response => {
              this.$message({
                message: '订单拆分成功',
                type: 'success'
              })
              this.editSplitloading = false
              this.editSplitVisible = false
              this.getData()
            }).catch(() => {
              this.editSplitloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cdfp-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
